import React from "react";
import { TitleStyled } from "./styled";

import { TTitle } from "./types";

export const Title = ({ title, fontSize, lineHeight }:TTitle) => {
  return <TitleStyled lineHeight={lineHeight} fontSize={fontSize}>{title}</TitleStyled>
}